class TimeoutManager {
  _timeoutList: any[];
  constructor() {
    this._timeoutList = [];
  }

  add(func, delay) {
    this._timeoutList.push(setTimeout(func, delay * 1000));
  }

  clearAll() {
    this._timeoutList.forEach(function (timeoutId) {
      clearTimeout(timeoutId);
    });
    this._timeoutList = [];
  }
}

export default TimeoutManager;
